import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'tx-multimedia-display',
  templateUrl: './tx-multimedia-display.component.html',
  styleUrls: ['./tx-multimedia-display.component.css']
})
export class TxMultimediaDisplayComponent implements OnInit {
  private _file: any;
  notVideoOrImage: boolean;
  @Input() removeIsEnabled: boolean;
  @Output() txOnRemoveFileFromList: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  get file() {
    return this._file;
  }

  @Input()
  set file(file) {
    this._file = file;
    this.setFileType();
  }

  ngOnInit() {
  }

  removeFileFromList() {
    this.txOnRemoveFileFromList.emit(this.file);
  }

  setFileType() {
    try {
      this.notVideoOrImage = !this.file.fileType.match(/IMAGE/)
        && !this.file.fileType.match(/VIDEO/);
    } catch (e) {
      this.notVideoOrImage = !this.file.file.type.match(/image\/\w+/)
        && !this.file.file.type.match(/video\/\w+/);
    }
  }

  openFile() {
    window.open(this.file.path, '_blank');
  }

  isImage() {
    try {
      return this.file.fileType.match(/IMAGE/);
    } catch (e) {
      return this.file.file.type.match(/image\/\w+/);
    }
  }

  isVideo() {
    try {
      return this.file.fileType.match(/VIDEO/);
    } catch (e) {
      return this.file.file.type.match(/video\/\w+/);
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-multimedia-display/tx-multimedia-display.component.ts